import React, { ChangeEvent, useEffect, useState } from 'react';
import swal from 'sweetalert';

import AdvancedSelect from '../../../../elements/formElements/AdvancedSelect';
import axiosCRM from '../../../../services/MyAxios';

interface Game {
    image: string;
    name: string;
    // eslint-disable-next-line camelcase
    creator_name: string;
}

interface CountOfGamesPerRowProps {
    currentValue: number;
    error: string;
    handleChange: (event: ChangeEvent<HTMLSelectElement>) => void;
}

const CountOfGamesPerRow: React.FC<CountOfGamesPerRowProps> = ({ currentValue, error, handleChange }) => {
    const [games, setGames] = useState<Game[]>([]);

    function getGames() {
        axiosCRM
            .get(`/crea/casino/api/games?limit=${currentValue}`)
            .then((data) => {
                setGames(data.data);
            })
            .catch(() => {
                swal({
                    title: 'Error',
                    text: 'Server error',
                    icon: 'error',
                });
            });
    }

    useEffect(() => {
        getGames();
    }, [currentValue]);

    let html = '';
    games.forEach((game, index) => {
        if (index >= currentValue) {
            return;
        }

        html += `<div>
            <img style="width: 100%" src="${game.image}" alt="${game.name}" />
            <div class="d-flex flex-column">
                <span>${game.name}</span>
                <span class="text-muted">${game.creator_name}</span>
            </div>
        </div>`;
    });

    return (
        <div>
            <AdvancedSelect
                field="games_per_row_count"
                value={currentValue}
                label="Count of games per row"
                required
                options={[3, 4, 5]}
                handleChange={handleChange}
                optionAsValue
                error={error}
            />
            <div className="preview">
                <p>Preview:</p>
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: `repeat(${currentValue}, 1fr)`,
                        gridGap: 14,
                    }}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: html }}
                />
            </div>
        </div>
    );
};

export default CountOfGamesPerRow;
